import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

const LoadingDots = ({ color = "#38AD3E", height = 20, width = 50, className = "" }) => {
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <ThreeDots
        height={height}
        width={width}
        color={color}
        ariaLabel="loading"
        visible={true}
      />
    </div>
  );
};

export default LoadingDots;
